import { StyledTextLeaf } from '@typedream/components';
import { createTPluginFactory } from '../../plate';
import { MARK_STYLED } from '../../pluginKeys';

export const createStyledTextPlugin = createTPluginFactory({
  key: MARK_STYLED,
  isLeaf: true,
  component: StyledTextLeaf,
});
